"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyBonusSend = copyBonusSend;
exports.deleteBonusSend = deleteBonusSend;
exports.exportBonusSendRecord = exportBonusSendRecord;
exports.getBonusRuleList = getBonusRuleList;
exports.getBonusSendDetail = getBonusSendDetail;
exports.getBonusSendList = getBonusSendList;
exports.getBonusSendRecordDetail = getBonusSendRecordDetail;
exports.getBonusSendRecordList = getBonusSendRecordList;
exports.getChannelList = getChannelList;
exports.getCouponPackagesWithItems = getCouponPackagesWithItems;
exports.resendFailedBonusSendRecord = resendFailedBonusSendRecord;
exports.saveBonusSend = saveBonusSend;
exports.testBonusSend = testBonusSend;
exports.toggleBonusSendStatus = toggleBonusSendStatus;
exports.uploadBonusSendImage = uploadBonusSendImage;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取优惠券发放列表
 * @param {Object} query - 查询参数
 */
function getBonusSendList(query) {
  return (0, _requestAuth.default)({
    url: '/bonusSend/list',
    method: 'get',
    params: query
  });
}

/**
 * 获取优惠券发放详情
 * @param {Number} id - 发放ID
 */
function getBonusSendDetail(id) {
  return (0, _requestAuth.default)({
    url: "/bonusSend/".concat(id),
    method: 'get'
  });
}

/**
 * 保存优惠券发放
 * @param {Object} data - 发放数据
 */
function saveBonusSend(data) {
  return (0, _requestAuth.default)({
    url: '/bonusSend',
    method: 'post',
    data: data
  });
}

/**
 * 删除优惠券发放
 * @param {Number} id - 发放ID
 */
function deleteBonusSend(id) {
  return (0, _requestAuth.default)({
    url: "/bonusSend/".concat(id),
    method: 'delete'
  });
}

/**
 * 复制优惠券发放活动
 * @param {Number} id - 发放ID
 */
function copyBonusSend(id) {
  return (0, _requestAuth.default)({
    url: "/bonusSend/copy/".concat(id),
    method: 'post'
  });
}

/**
 * 启用/禁用优惠券发放
 * @param {Number} id - 发放ID
 * @param {Number} val - 状态值
 * @param {String} field - 字段名（enabled或canShare）
 */
function toggleBonusSendStatus(id, val) {
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'enabled';
  return (0, _requestAuth.default)({
    url: "/bonusSend/toggleStatus/".concat(id),
    method: 'post',
    data: (0, _defineProperty2.default)({}, field, val)
  });
}

/**
 * 获取套券规则列表
 */
function getBonusRuleList() {
  return (0, _requestAuth.default)({
    url: '/bonusSend/bonusRules',
    method: 'get'
  });
}

/**
 * 获取渠道列表
 */
function getChannelList() {
  return (0, _requestAuth.default)({
    url: '/bonusSend/channels',
    method: 'get'
  });
}

/**
 * 上传图片
 * @param {File} file - 图片文件
 */
function uploadBonusSendImage(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/bonusSend/uploadImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 获取所有有效券包及其明细
 */
function getCouponPackagesWithItems() {
  return (0, _requestAuth.default)({
    url: '/couponPackage/listEnabledWithItems',
    method: 'get'
  });
}

/**
 * 测试接口
 */
function testBonusSend() {
  return (0, _requestAuth.default)({
    url: '/bonusSend/test',
    method: 'get'
  });
}

/**
 * 获取优惠券发放记录列表（包含明细）
 * @param {Object} query - 查询参数
 */
function getBonusSendRecordList(query) {
  return (0, _requestAuth.default)({
    url: '/xyBonusSendRecord/page',
    method: 'get',
    params: query
  });
}

/**
 * 获取优惠券发放记录详情（包含明细列表）
 * @param {Number} id - 记录ID
 */
function getBonusSendRecordDetail(id) {
  return (0, _requestAuth.default)({
    url: "/xyBonusSendRecord/".concat(id),
    method: 'get'
  });
}

/**
 * 导出优惠券发放记录
 * @param {Object} params - 查询参数
 */
function exportBonusSendRecord(params) {
  return (0, _requestAuth.default)({
    url: '/xyBonusSendRecord/export',
    method: 'get',
    params: params
  });
}

/**
 * 重新发放失败的明细
 * @param {Number} recordId - 发放记录ID
 */
function resendFailedBonusSendRecord(recordId) {
  return (0, _requestAuth.default)({
    url: '/xyBonusSendRecord/resendFailed',
    method: 'post',
    data: {
      recordId: recordId
    }
  });
}